import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=74a4ad4b&scoped=true"
import script from "./Topic.vue?vue&type=script&lang=js"
export * from "./Topic.vue?vue&type=script&lang=js"
import style0 from "./Topic.vue?vue&type=style&index=0&id=74a4ad4b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a4ad4b",
  null
  
)

export default component.exports